import React from "react";
import { Stack, Typography } from "@mui/material";

import { BlogCards } from "src/widgets/BlogCards";
import { RoutePaths } from "src/app/model";

export const BlogsPage: React.FC = () => {
  return (
    <Stack
      id={RoutePaths.BLOGS}
      width={1}
      direction="column"
      justifyContent="center"
      alignItems="center"
      gap={4}
      sx={{
        scrollMarginTop: 80,
      }}
    >
      <Typography
        color="text.secondary"
        variant="h5"
        fontWeight="light"
        textTransform="uppercase"
      >
        Blog
      </Typography>

      <Stack direction="row" gap={2}>
        <Typography color="text.secondary" variant="h4">
          Some
        </Typography>
        <Typography color="primary" variant="h4">
          Description
        </Typography>
      </Stack>

      <BlogCards />
    </Stack>
  );
};
